"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _lodash = _interopRequireDefault(require("lodash"));

var _jquery = _interopRequireDefault(require("jquery"));

var _consts = _interopRequireDefault(require("@wix/photography-client-lib/dist/src/utils/consts"));

var _windowWrapper = _interopRequireDefault(require("@wix/photography-client-lib/dist/src/sdk/windowWrapper"));

var _galleryItem = _interopRequireDefault(require("pro-gallery/dist/src/components/item/galleryItem"));

var _swipper = _interopRequireDefault(require("./swipper.js"));

var _bottomLink = _interopRequireDefault(require("./bottomLink.js"));

var _fullscreenSlider = _interopRequireDefault(require("./fullscreenSlider.js"));

var _fullscreenDesktopNavbar = _interopRequireDefault(require("./fullscreenDesktopNavbar.js"));

var _FullscreenMobileBar = _interopRequireDefault(require("./FullscreenMobileBar"));

var _fullscreenSidebar = _interopRequireDefault(require("./fullscreenSidebar.js"));

var _fullscreenShareScreen = _interopRequireDefault(require("./fullscreenShareScreen.js"));

var _utils = require("../utils");

var _itemResizer = require("@wix/photography-client-lib/dist/src/item/itemResizer");

var _viewModeWrapper = require("../utils/viewModeWrapper.js");

var _fullscreenEvents = _interopRequireDefault(require("../constants/fullscreenEvents"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

_utils.utils.fixViewport('Fullscreen');

function defaultNavigateAction(url) {
  _windowWrapper["default"].open(url);
}

var ProFullscreen =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(ProFullscreen, _React$Component);

  function ProFullscreen(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _defineProperty(_assertThisInitialized(_this), "handleMouseMove", _lodash["default"].throttle(function () {
      (0, _jquery["default"])('.fullscreen-icon').show().css('opacity', '1');
      (0, _jquery["default"])('body').removeClass('no-cursor');
      clearTimeout(_this.mouseMovedTimeout);

      if (_this.state.isExpandedView) {
        if (!_this.getItem().isDemo && !_utils.utils.isTouch()) {
          _this.mouseMovedTimeout = setTimeout(function () {
            (0, _jquery["default"])('body').addClass('no-cursor');
            (0, _jquery["default"])('.fullscreen-icon').css('opacity', '0');
          }, 3000);
        }
      }
    }, 100).bind(_assertThisInitialized(_this)));

    _defineProperty(_assertThisInitialized(_this), "handleKeypress", _lodash["default"].throttle(function (e) {
      var isRTL = _this.props.styles.isRTL;

      switch (e.keyCode || e.charCode) {
        case 38: //up

        case 37: //left

        case 33:
          //page up
          e.preventDefault();

          _this.nextSlide(isRTL ? 1 : -1);

          return false;

        case 39: //right

        case 40: //down

        case 34:
          //page down
          e.preventDefault();

          _this.nextSlide(isRTL ? -1 : 1);

          return false;

        case 27:
          //esc
          e.preventDefault();

          _this.handleMouseMove();

          _this.closeExpandBrowser();

          return false;

        case 9:
          //tab
          var activeElementClasses = document.activeElement.classList;

          if (e.shiftKey) {
            if (activeElementClasses.contains('pro-fullscreen-arrow') && ( //one of the arrows
            activeElementClasses.contains('arrow-left') || //left arrow
            activeElementClasses.contains('arrow-right') && //or right arrow when left arrow is disabled
            _this.state.current.idx <= 0)) {
              // the left arrow or (the right arrow when left arrow is disabled) is the last icon in the shift-tab-order.
              // if another shift-tab was pressed, we want to focus again on the close icon
              e.preventDefault();

              _this.setState({
                shouldRefocusOnCloseXButton: true
              }, function () {
                _this.setState({
                  shouldRefocusOnCloseXButton: false
                });
              });

              return false;
            }
          } else {
            if (activeElementClasses.contains('pro-fullscreen-x-button')) {
              // close icon is the last icon in fullscreen tab-order.
              // if another tab was pressed, we want to focus again on one of the arrows (the correct one).
              e.preventDefault();

              _this.setState({
                refocusArrows: true
              }, function () {
                _this.setState({
                  refocusArrows: false
                });
              });

              return false;
            }
          }

          break;

        default:
      }

      _this.handleMouseMove();

      return true; //continue handling the original keyboard event
    }, 100).bind(_assertThisInitialized(_this)));

    _defineProperty(_assertThisInitialized(_this), "onFullscreenChange", function () {
      // exit fullscreen
      if (!_windowWrapper["default"].document.fullscreenElement && !_windowWrapper["default"].document.webkitIsFullScreen && !_windowWrapper["default"].document.mozFullScreen && !_windowWrapper["default"].document.msFullscreenElement) {
        if (_this.state.isExpandedView) {
          _this.setState({
            isExpandedView: false,
            showInfo: _this.props.styles.defaultShowInfoExpand && _this.state.current.hasInfo,
            infoToggledByUser: false
          });
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onOrientationChange", function () {
      _this.isLandscape = _this.isLandscapeInMobile();

      _this.setState({
        isMobileZoom: _this.isLandscape,
        isExpandedView: _this.isLandscape
      });
    });

    _this.eventsListener = _this.eventsListener.bind(_assertThisInitialized(_this));
    _this.fadeToNextSlide = _this.fadeToNextSlide.bind(_assertThisInitialized(_this));
    _this.toggleZoomMode = _this.toggleZoomMode.bind(_assertThisInitialized(_this));
    _this.getItemsToDisplay = _this.getItemsToDisplay.bind(_assertThisInitialized(_this));
    _this.nextSlide = _this.nextSlide.bind(_assertThisInitialized(_this));
    _this.toggleShareScreen = _this.toggleShareScreen.bind(_assertThisInitialized(_this));
    _this.toggleInfo = _this.toggleInfo.bind(_assertThisInitialized(_this));
    _this.expandBrowser = _this.expandBrowser.bind(_assertThisInitialized(_this));
    _this.closeExpandBrowser = _this.closeExpandBrowser.bind(_assertThisInitialized(_this));
    _this.extraImages = _utils.utils.isMobile() ? 2 : 5; //number of images to preload on each side of the fullscreen

    if (typeof props.viewMode !== 'undefined') {
      _viewModeWrapper.viewModeWrapper.setViewMode(props.viewMode);
    }

    _this.actions = {
      toggleInfo: _this.toggleInfo,
      toggleShareScreen: _this.toggleShareScreen,
      next: _this.nextSlide,
      expandBrowser: _this.expandBrowser,
      closeExpandBrowser: _this.closeExpandBrowser,
      eventsListener: _this.eventsListener
    }; //TODO: replace with css modules

    (0, _utils.replaceWindowElement)({
      type: 'style',
      id: 'inlineDynamicFullscreenWixParamsCss',
      attributes: {
        type: 'text/css'
      },
      innerHTML: (0, _utils.createFullscreenStyle)(props.styles),
      parentElement: _windowWrapper["default"].document.getElementsByTagName('head')[0]
    });

    if (props.styles.googleFontsCssUrl) {
      (0, _utils.replaceWindowElement)({
        type: 'style',
        id: 'inlineDynamicFullscreenWixParamsFont',
        attributes: {
          type: 'text/css',
          rel: 'stylesheet',
          href: props.styles.googleFontsCssUrl
        },
        parentElement: _windowWrapper["default"].document.getElementsByTagName('head')[0]
      });
    }

    _this.state = {
      isExpandedView: !!props.styles.initialExpandedView,
      isMobileZoom: false,
      animating: false,
      showShareScreen: false,
      showShare: false,
      refocusArrows: false,
      initialArrowsFocus: false,
      shouldRefocusOnCloseXButton: false
    };
    _this.state.currentWindow = _this.getCurrentWindowState();
    _this.state.current = _this.getCurrentItemState(props.initialIdx);
    var eventData = {
      item: _this.state.current.item
    };

    _this.eventsListener(_fullscreenEvents["default"].UPDATE_CURRENT_ITEM, eventData);

    _this.state.showInfo = props.styles && !props.styles.initialExpandedView && props.styles.defaultShowInfoExpand && _this.state.current.hasInfo;
    _this.isLandscape = _this.isLandscapeInMobile();
    return _this;
  }

  var _proto = ProFullscreen.prototype;

  _proto.eventsListener = function eventsListener(eventName, eventData) {
    if (typeof this.props.eventsListener === 'function') {
      this.props.eventsListener(eventName, eventData);
    }
  };

  _proto.isLandscapeInMobile = function isLandscapeInMobile() {
    return _utils.utils.isMobile() && (_windowWrapper["default"].orientation === 90 || _windowWrapper["default"].orientation === -90);
  };

  _proto.initEvents = function initEvents() {
    _windowWrapper["default"].addEventListener('keydown', this.handleKeypress);

    _windowWrapper["default"].addEventListener('fullscreenchange', this.onFullscreenChange);

    _windowWrapper["default"].addEventListener('webkitfullscreenchange', this.onFullscreenChange);

    _windowWrapper["default"].addEventListener('mozfullscreenchange', this.onFullscreenChange);

    _windowWrapper["default"].addEventListener('MSFullscreenChange', this.onFullscreenChange);

    _windowWrapper["default"].addEventListener('mousemove', this.handleMouseMove);

    _windowWrapper["default"].addEventListener('mousedown', this.handleMouseMove);

    _windowWrapper["default"].addEventListener('orientationchange', this.onOrientationChange);
  };

  _proto.clearEvents = function clearEvents() {
    _windowWrapper["default"].removeEventListener('keydown', this.handleKeypress);

    _windowWrapper["default"].removeEventListener('fullscreenchange', this.onFullscreenChange);

    _windowWrapper["default"].removeEventListener('webkitfullscreenchange', this.onFullscreenChange);

    _windowWrapper["default"].removeEventListener('mozfullscreenchange', this.onFullscreenChange);

    _windowWrapper["default"].removeEventListener('MSFullscreenChange', this.onFullscreenChange);

    _windowWrapper["default"].removeEventListener('mousemove', this.handleMouseMove);

    _windowWrapper["default"].removeEventListener('mousedown', this.handleMouseMove);

    _windowWrapper["default"].removeEventListener('orientationchange', this.onOrientationChange);
  };

  _proto.getCurrentItemState = function getCurrentItemState(idx) {
    if (_lodash["default"].isUndefined(idx)) {
      idx = this.state.current.idx || 0;
    }

    var item = this.getItem(idx);
    return {
      idx: idx,
      item: item,
      hasInfo: this.hasInfo(idx),
      pos: this.getItemsDisplayRange(),
      itemLoveData: this.props.itemsLoveData[item.id]
    };
  };

  _proto.shouldShowInfo = function shouldShowInfo() {
    if (!this.state && this.props.styles.initialExpandedView) {
      return false;
    } else if (this.state && this.state.isExpandedView) {
      return false;
    } else if (this.hasAdditionalSidebarElement() && !_utils.utils.isMobile()) {
      return true;
    } else if (this.state) {
      return this.state.showInfo;
    } else {
      return this.props.styles.defaultShowInfoExpand && !_utils.utils.isSmallScreen();
    }
  };

  _proto.currentWindowSize = function currentWindowSize() {
    var isMobile = _utils.utils.isMobile();

    var dim = {
      width: Math.round(this.props.container.width / _utils.utils.getViewportScaleRatio()),
      height: Math.round(this.props.container.height / _utils.utils.getViewportScaleRatio())
    };
    var mobilePadding = isMobile ? _consts["default"].dimensions.MOBILE_PADDING : _consts["default"].dimensions.NO_PADDING;

    if (this.shouldShowInfo()) {
      // Without Side Bar width which is 30 percent of the window
      return this.props.styles.expandInfoPosition === _consts["default"].expandInfoPositions.BOTTOM && !isMobile ? {
        width: dim.width,
        height: this.state.current.item.description && this.props.styles.allowDescriptionExpand || !_lodash["default"].isUndefined(this.state.current.item.link.data) ? dim.height * 95 / 100 : dim.height
      } : {
        width: dim.width * 70 / 100,
        height: dim.height - mobilePadding
      };
    } else if (mobilePadding !== 0 && !this.isLandscape) {
      return {
        width: dim.width,
        height: dim.height - mobilePadding
      };
    } else {
      return dim;
    }
  };

  _proto.getCurrentWindowScale = function getCurrentWindowScale() {
    var _this2 = this;

    var scale = {};

    if (this.state.isExpandedView || _utils.utils.isSmallScreen()) {
      scale = {
        horizontal: 1,
        vertical: 1
      };
    } else {
      var w = this.currentWindowSize();
      scale = {
        horizontal: (w.width - 100 * 2) / w.width,
        vertical: (w.height - 100 * 2) / w.height
      };
    }

    scale.min = function (item) {
      if (_this2.state.isExpandedView || _utils.utils.isSmallScreen()) {
        return 1;
      } else {
        var _w = _this2.currentWindowSize();

        var horizontal = (_w.width - 100 * 2) / item.width;
        var vertical = (_w.height - 100 * 2) / item.height;
        return Math.min(horizontal, vertical);
      }
    };

    return scale;
  };

  _proto.getCurrentWindowState = function getCurrentWindowState() {
    return {
      size: this.currentWindowSize(),
      expanded: this.state.isExpandedView,
      scale: this.getCurrentWindowScale()
    };
  };

  _proto.hasInfo = function hasInfo(idx) {
    var curItem;

    if (!_lodash["default"].isUndefined(idx)) {
      curItem = this.getItem(idx);
    } else if (_lodash["default"].isUndefined(this.state.current)) {
      return false;
    } else {
      curItem = this.getItem(_lodash["default"].get(this, 'state.current.idx') || 0);
    }

    var hasInfo = _utils.utils.getTitleOrFilename(curItem.title, curItem.fileName) && this.props.styles.allowTitleExpand || curItem.description && this.props.styles.allowDescriptionExpand || !_lodash["default"].isUndefined(curItem.link.data);
    return hasInfo;
  };

  _proto.getItem = function getItem(idx) {
    var _this3 = this;

    var emptyItem = function emptyItem() {
      return new _galleryItem["default"]({
        dto: {
          itemId: 'empty-item',
          mediaUrl: '',
          metaData: {
            height: 3744,
            width: 3744
          }
        },
        resizeMediaUrl: (0, _itemResizer.resizeMediaUrlWithWatermark)(_this3.props.watermark)
      });
    };

    if (!this.state) {
      return emptyItem();
    } else if (!_lodash["default"].isUndefined(idx) && _lodash["default"].isArray(this.props.items)) {
      return this.getOrCreateGalleryItem(idx) || emptyItem();
    } else if (_lodash["default"].get(this, 'state.current.item.id')) {
      return this.state.current.item;
    } else if (_lodash["default"].get(this, 'state.current.idx')) {
      return this.getOrCreateGalleryItem(_lodash["default"].get(this, 'state.current.idx'));
    } else if (_lodash["default"].get(this, 'prerenderedItem.id')) {
      return this.prerenderedItem;
    } else {
      return emptyItem();
    }
  };

  _proto.getNextitem = function getNextitem(idx, direction) {
    var loop = this.props.styles.fullscreenLoop;
    var numOfitems = this.props.items.length;
    var next = idx + direction;

    if (next < 0) {
      return idx;
    } else if (next === numOfitems) {
      return loop ? 0 : idx;
    } else {
      return next;
    }
  };

  _proto.getItemsDisplayRange = function getItemsDisplayRange() {
    var range = _utils.utils.isTouch() ? 2 : 5;

    if (!this.state) {
      return range;
    }

    var numOfitems = this.props.items.length - 1;

    if (numOfitems > 0 & this.props.styles.fullscreenLoop) {
      return Math.min(range, Math.floor(numOfitems / 2));
    } else {
      return Math.min(range, numOfitems);
    }
  };

  _proto.getOrCreateGalleryItem = function getOrCreateGalleryItem(itemIdx) {
    //calc itemParams and clear cache if one of them had changed
    var itemParams = {
      windowSize: this.currentWindowSize(),
      styleParams: this.props.styles,
      watermark: this.props.watermark
    };
    var stringifiedItemParams = JSON.stringify(itemParams);
    var shouldClearGalleryItems = stringifiedItemParams !== this.lastItemParams;

    if (shouldClearGalleryItems) {
      this.galleryItems = [];
      this.lastItemParams = stringifiedItemParams;
    }

    if (!this.galleryItems[itemIdx]) {
      var item = this.props.items[itemIdx];
      this.galleryItems[itemIdx] = item ? (0, _utils.prepareFullscreenItem)(_objectSpread({
        item: item,
        itemIdx: itemIdx,
        scale: this.getCurrentWindowScale(),
        isExpandedView: this.state.isExpandedView,
        isMobileZoom: this.state.isMobileZoom,
        watermark: this.props.watermark
      }, itemParams)) : undefined;
    }

    return this.galleryItems[itemIdx];
  };

  _proto.getMoreItemsIfNeeded = function getMoreItemsIfNeeded(nextIdx) {
    if (this.props.totalItemsCount > this.props.items.length && nextIdx > this.props.items.length - this.extraImages) {
      var itemsLength = this.props.items.length;
      this.eventsListener(_fullscreenEvents["default"].NEED_MORE_ITEMS, itemsLength);
    }
  };

  _proto.getItemsToDisplay = function getItemsToDisplay() {
    var items = this.props.items;
    var idx = this.state.current.idx;
    var range = this.getItemsDisplayRange();
    var startIdx = idx - range;
    var endIdx = idx + range; //create a fixed size items array (size = range * 2 + 1)

    var itemsToDisplay = [];
    var numOfitems = items.length;
    var itemIdx;

    for (var i = startIdx; i <= endIdx; i++) {
      if (this.props.styles.fullscreenLoop) {
        itemIdx = i % numOfitems;
      } else {
        itemIdx = i;
      }

      itemsToDisplay.push(this.getItem(itemIdx));
    }

    return itemsToDisplay;
  };

  _proto.closeExpandBrowser = function closeExpandBrowser(shouldCloseFullscreen) {
    var _this4 = this;

    if (shouldCloseFullscreen === void 0) {
      shouldCloseFullscreen = false;
    }

    if (this.state.isExpandedView) {
      this.setState({
        isExpandedView: false,
        showInfo: this.props.styles.defaultShowInfoExpand && this.state.current.hasInfo,
        infoToggledByUser: false
      }, function () {
        _this4.eventsListener(_fullscreenEvents["default"].TOGGLE_BROWSER_FULLSCREEN);

        if (shouldCloseFullscreen) {
          var eventData = {
            itemIdx: _this4.state.current.idx,
            animationDuration: 0
          };

          _this4.eventsListener(_fullscreenEvents["default"].CLOSE_FULLSCREEN, eventData);
        }
      });
    } else {
      var eventData = {
        itemIdx: this.state.current.idx
      };
      this.eventsListener(_fullscreenEvents["default"].CLOSE_FULLSCREEN, eventData);
    }
  };

  _proto.expandBrowser = function expandBrowser() {
    var _this5 = this;

    this.setState({
      isExpandedView: true,
      showInfo: false,
      infoToggledByUser: false
    }, function () {
      return _this5.eventsListener(_fullscreenEvents["default"].TOGGLE_BROWSER_FULLSCREEN);
    });
  };

  _proto.nextSlide = function nextSlide(direction, nextIdx, callback) {
    var _this6 = this;

    //this method should be called AFTER the animation is finished!
    if (!_lodash["default"].isFunction(callback)) callback = _lodash["default"].noop; //disable circling photos

    nextIdx = _lodash["default"].isUndefined(nextIdx) || _lodash["default"].isNull(nextIdx) ? this.getNextitem(Number(this.state.current.idx), direction) : nextIdx;

    if (nextIdx === this.state.current.idx) {
      callback();
      return;
    }

    if (_lodash["default"].isUndefined(nextIdx)) {
      callback();
      this.closeFullscreen();
    } else {
      var currentItem = this.getCurrentItemState(nextIdx);
      this.setState({
        current: currentItem,
        showInfo: !this.state.isExpandedView && currentItem.hasInfo && (this.props.styles.defaultShowInfoExpand || this.state.infoToggledByUser),
        animating: false,
        direction: 0
      }, function () {
        _this6.getMoreItemsIfNeeded(nextIdx);

        _this6.eventsListener(_fullscreenEvents["default"].ON_NEXT_SLIDE, nextIdx); //iFrame only (pro-fullscreen-tpa-wrapper)


        var eventData = {
          item: currentItem.item
        };

        _this6.eventsListener(_fullscreenEvents["default"].UPDATE_CURRENT_ITEM, eventData);

        callback();
      });
    }
  };

  _proto.toggleInfo = function toggleInfo(forceVal) {
    if (this.state.isExpandedView) {
      this.setState({
        showInfo: false
      });
    } else {
      var showInfo = _lodash["default"].isUndefined(forceVal) ? !this.state.showInfo : forceVal;

      _utils.utils.setStateAndLog(this, 'toggleInfo', {
        showInfo: showInfo
      });

      this.setState({
        infoToggledByUser: showInfo
      });
    }
  };

  _proto.toggleShareScreen = function toggleShareScreen() {
    this.setState({
      showShareScreen: !this.state.showShareScreen
    });
  } //--------------------------------------------| UI Actions |-------------------------------------------//
  ;

  _proto.fadeToNextSlide = function fadeToNextSlide(direction) {
    var _this7 = this;

    if (direction !== 0 && !this.state.animating) {
      _utils.utils.setStateAndLog(this, 'fadeToNextSlide animation start', {
        animating: true,
        direction: direction
      }, function () {
        setTimeout(function () {
          _this7.actions.next(direction); //triggers react after the animation is complete


          _this7.fixTransformForApple();
        }, 400);
      });
    }
  };

  _proto.toggleZoomMode = function toggleZoomMode(valueOrEvent) {
    if (_lodash["default"].isBoolean(valueOrEvent)) {
      if (this.isLandscape) {
        var eventData = {
          itemIdx: this.state.current.idx
        };
        this.eventsListener(_fullscreenEvents["default"].CLOSE_FULLSCREEN, eventData);
      } else {
        this.setState({
          isMobileZoom: valueOrEvent
        });
      }
    } else {
      var tapTargetClass = _lodash["default"].get(valueOrEvent, 'target.className') || '';

      if (typeof tapTargetClass === 'string' || tapTargetClass instanceof String) {
        if (tapTargetClass.indexOf('fullscreen-item') >= 0 || tapTargetClass.indexOf('fullscreen-preload') >= 0) {
          //make sure that the tap is on the image / preload
          this.setState({
            // TURBO: use prevState func
            isMobileZoom: !this.state.isMobileZoom
          });
        }
      } else {// console.log('Not Toggling Zoom Mode', (_.get(tapEvent, 'target.className') || '').indexOf('fullscreen-item'), (_.get(tapEvent, 'target.className')), tapEvent);
      }
    }
  } //-----------------------------------------| DOM Manipulation |----------------------------------------//
  ;

  _proto.fixLinkLineHeight = function fixLinkLineHeight() {
    var curItem = this.state.current.item;

    if (curItem.linkUrl && curItem.linkText) {
      //patch to limit link lines to 2
      try {
        var elem = (0, _jquery["default"])(_reactDom["default"].findDOMNode(this));
        if (!elem) return;
        var link = elem.find('.fullscreen-side-bar-exif.pro-fullscreen-link');

        if (link.length !== 1) {
          return;
        }

        var lineHeight = parseInt(link.css('line-height'));
        var numOfLines = 2;
        link.height(numOfLines * lineHeight);
        link.css({
          '-webkit-line-clamp': numOfLines + ''
        });
      } catch (e) {
        return;
      }
    }
  };

  _proto.fixTransformForApple = function fixTransformForApple() {
    if (_utils.utils.isiOS()) {
      (0, _jquery["default"])('.pro-fullscreen-swipe-wrap .pro-fullscreen-slide').css('will-change', 'transform');
    } else if (_utils.utils.browserIs('safari')) {
      var transform = 'translate3d(0, 0, 0)';
      var duration = '0ms';
      (0, _jquery["default"])('.pro-fullscreen-swipe-wrap .pro-fullscreen-slide').css('will-change', 'transform').css('transform', transform).css('-webkit-transform', transform).css('-moz-transform', transform).css('-ms-transform', transform).css('-o-transform', transform).css('transition-duration', duration).css('-webkit-transition-duration', duration).css('-moz-transition-duration', duration).css('-ms-transition-duration', duration).css('-o-transition-duration', duration);
    }
  };

  _proto.hasContainerChanged = function hasContainerChanged(container, prevContainer) {
    return container.width !== prevContainer.width || container.height !== prevContainer.height;
  } //------------------------------------------| React methods |------------------------------------------//
  ;

  _proto.componentDidMount = function componentDidMount() {
    this.eventsListener(_fullscreenEvents["default"].FULLSCREEN_LOADED, this.state.current.item);

    if (_utils.utils.isTouch()) {
      this.swipper = new _swipper["default"]({
        container: this.props.container,
        onTap: this.toggleZoomMode,
        allowSwipe: true,
        allowPinch: this.state.isMobileZoom && !_lodash["default"].get(this, 'props.current.item.isVideo'),
        allowScroll: !this.state.isMobileZoom,
        mobileSwipeAnimation: this.props.styles.mobileSwipeAnimation,
        isRTL: this.props.styles.isRTL
      }, this.actions.next);
      this.swipper.update();
    }

    this.isLandscape = this.isLandscapeInMobile();

    if (this.isLandscape) {
      this.setState({
        isMobileZoom: true,
        isExpandedView: true
      });
    }

    this.initEvents();
    this.handleMouseMove(); //show the icons (that will show on mouse move) on startup
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    var _this8 = this;

    //check is this is really needed (do not do on every state change)
    this.fixLinkLineHeight();
    this.fixTransformForApple();
    var isMobileZoom = this.state.isMobileZoom;
    var mobileSwipeAnimation = this.props.styles.mobileSwipeAnimation;

    if (this.swipper) {
      this.swipper.enable();
      this.swipper.update();

      if (isMobileZoom !== prevState.isMobileZoom || mobileSwipeAnimation !== prevProps.styles.mobileSwipeAnimation || this.hasContainerChanged(this.props.container, prevProps.container)) {
        this.swipper.init({
          container: this.props.container,
          onTap: this.toggleZoomMode,
          allowSwipe: true,
          allowPinch: !!isMobileZoom,
          allowScroll: !isMobileZoom,
          mobileSwipeAnimation: mobileSwipeAnimation
        });
      }

      this.element && this.element.focus();
    }

    if (_utils.utils.isOOI()) {
      if (!prevProps.styles.isAccessible && this.props.styles.isAccessible) {
        this.setState({
          initialArrowsFocus: true
        }, function () {
          _this8.setState({
            initialArrowsFocus: false
          });
        });
      }
    }

    if (this.props.itemsLoveData !== prevProps.itemsLoveData) {
      var currItem = this.getCurrentItemState(this.state.current.idx);
      this.setState({
        current: currItem
      });
    }

    if (this.props.viewMode !== prevProps.viewMode) {
      _viewModeWrapper.viewModeWrapper.setViewMode(this.props.viewMode);
    }
  } //WARNING! To be deprecated in React v17. Use new lifecycle static getDerivedStateFromProps instead.
  ;

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (!_lodash["default"].isEqual(this.props.styles, nextProps.styles) || !_lodash["default"].isEqual(this.props.container, nextProps.container)) {
      (0, _utils.replaceWindowElement)({
        type: 'style',
        id: 'inlineDynamicFullscreenWixParamsCss',
        attributes: {
          type: 'text/css'
        },
        innerHTML: (0, _utils.createFullscreenStyle)(nextProps.styles),
        parentElement: _windowWrapper["default"].document.getElementsByTagName('head')[0]
      });

      if (nextProps.styles.googleFontsCssUrl) {
        (0, _utils.replaceWindowElement)({
          type: 'style',
          id: 'inlineDynamicFullscreenWixParamsFont',
          attributes: {
            type: 'text/css',
            rel: 'stylesheet',
            href: nextProps.styles.googleFontsCssUrl
          },
          parentElement: _windowWrapper["default"].document.getElementsByTagName('head')[0]
        });
      }

      this.setState({
        showInfo: !this.state.isExpandedView && this.state.current.hasInfo && (nextProps.styles.defaultShowInfoExpand || this.state.infoToggledByUser),
        currentWindow: this.getCurrentWindowState()
      });
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.clearEvents();
  } //____________________________________getters_____________________________________
  ;

  _proto.getTopMobileBar = function getTopMobileBar(curItem) {
    return _react["default"].createElement(_FullscreenMobileBar["default"], {
      id: curItem.id,
      idx: curItem.idx,
      itemId: this.state.current.item.id,
      additionalNavbarElement: this.props.additionalNavbarElement,
      current: this.getCurrentItemState(this.state.current.idx),
      styleParams: this.props.styles,
      actions: this.actions,
      showInfo: this.state.showInfo,
      isFirst: true,
      showShareScreen: this.state.showShareScreen,
      isPreview: this.props.isPreview
    });
  };

  _proto.getSideBar = function getSideBar() {
    var _this9 = this;

    return _react["default"].createElement(_fullscreenSidebar["default"], {
      ref: function ref(element) {
        return _this9.sidebar = element;
      },
      current: this.state.current,
      locale: this.props.locale,
      deviceType: this.props.deviceType,
      viewMode: this.props.viewMode,
      styleParams: this.props.styles,
      showInfo: this.state.showInfo,
      actions: this.actions,
      currentWindow: this.getCurrentWindowState(),
      customSidebarRenderer: this.props.customSidebarRenderer,
      additionalSidebarElement: this.props.additionalSidebarElement,
      additionalNavbarElement: this.props.additionalNavbarElement,
      customMobileSidebarRenderer: this.props.customMobileSidebarRenderer,
      isAdditionalMobileSidebarOpened: this.props.isAdditionalMobileSidebarOpened,
      noFollowForSEO: this.props.noFollowForSEO
    });
  };

  _proto.hasAdditionalSidebarElement = function hasAdditionalSidebarElement() {
    if (_utils.utils.isMobile()) {
      var customMobileSidebarRenderer = this.props.customMobileSidebarRenderer;
      return typeof customMobileSidebarRenderer === 'function';
    } else {
      var additionalSidebarElement = this.props.additionalSidebarElement;
      return typeof additionalSidebarElement === 'function';
    }
  };

  _proto.getSmallScreenArrows = function getSmallScreenArrows(isNewLayout, isSmallScreen, isTouch, totalItems) {
    return false;
  };

  _proto.getBottomLinkContainer = function getBottomLinkContainer() {
    return this.state.current.item.hasLink && this.props.styles.allowLinkExpand ? _react["default"].createElement(_bottomLink["default"], {
      current: this.state.current,
      actions: this.actions
    }) : null;
  };

  _proto.getSlider = function getSlider(totalItems) {
    return _react["default"].createElement(_fullscreenSlider["default"], {
      isExpandedView: this.state.isExpandedView,
      items: this.getItemsToDisplay(),
      isLandscape: this.isLandscape,
      current: this.getCurrentItemState(this.state.current.idx),
      currentWindow: this.getCurrentWindowState(),
      styleParams: this.props.styles,
      animating: this.state.animating,
      direction: this.state.direction,
      totalItems: totalItems,
      isMobileZoom: this.state.isMobileZoom,
      additionalSidebarElement: this.props.additionalSidebarElement,
      showShareScreen: this.state.showShareScreen,
      customMobileSidebarRenderer: this.props.customMobileSidebarRenderer,
      refocusArrows: this.state.refocusArrows,
      initialArrowsFocus: this.state.initialArrowsFocus,
      actions: _lodash["default"].merge(this.actions, {
        fadeToNextSlide: this.fadeToNextSlide
      })
    });
  };

  _proto.getDesktopNavbar = function getDesktopNavbar(curItem, totalItems) {
    return _react["default"].createElement(_fullscreenDesktopNavbar["default"], {
      id: curItem.id,
      idx: curItem.idx,
      itemId: curItem.id,
      totalItems: totalItems,
      additionalNavbarElement: this.props.additionalNavbarElement,
      current: this.getCurrentItemState(this.state.current.idx),
      currentWindow: this.getCurrentWindowState(),
      styleParams: this.props.styles,
      showInfo: this.state.showInfo,
      navigatedInto: this.props.navigatedInto,
      actions: _lodash["default"].merge(this.actions, {
        fadeToNextSlide: this.fadeToNextSlide
      }),
      isPreview: this.props.isPreview,
      shouldRefocusOnCloseXButton: this.state.shouldRefocusOnCloseXButton
    });
  };

  _proto.getFullscreenShareScreen = function getFullscreenShareScreen() {
    return _utils.utils.isMobile() ? _react["default"].createElement(_fullscreenShareScreen["default"], {
      current: this.state.current,
      styleParams: this.props.styles,
      showShareScreen: this.state.showShareScreen,
      actions: this.actions
    }) : null;
  };

  _proto.getCloseButton = function getCloseButton() {
    var _this10 = this;

    return _react["default"].createElement("button", {
      className: "fullscreen-icon fullscreen-toggle-zoom progallery-svg-font-icons-close-x ",
      onClick: function onClick() {
        return _this10.toggleZoomMode(false);
      }
    });
  };

  _proto.getFullscreenClasses = function getFullscreenClasses() {
    var versionClassName = 'v2';
    var expandedClassName = this.state.isExpandedView ? ' pro-fullscreen-expanded ' : '';
    var themeClassName = _utils.utils.parseGetParam('theme') === 'dark' ? ' fullscreen-dark' : ' fullscreen-bright';
    var accessibilityClassName = '';

    if (_utils.utils.isOOI()) {
      accessibilityClassName = this.props.styles.isAccessible ? ' pro-fullscreen-accessible ' : '';
    } else {
      accessibilityClassName = _utils.utils.isAccessibilityEnabled() ? ' pro-fullscreen-accessible ' : '';
    }

    var mobileClassName = _utils.utils.isMobile() ? 'pro-fullscreen-mobile' : '';
    return "fullscreen pro-fullscreen pro-fullscreen-inline-styles inline-styles pro-fullscreen-" + versionClassName + " " + expandedClassName + " " + themeClassName + " " + accessibilityClassName + " " + mobileClassName;
  } //________________________________________________________________________________
  ;

  _proto.render = function render() {
    var _this11 = this;

    var totalItems = this.props.items.length;

    var isMobile = _utils.utils.isMobile();

    var curItem = this.state.current.item;

    if (_utils.utils.isVerbose()) {
      console.timeEnd('Time in React');
      console.log('Render FullscreenView', this.props, this.state);
    }

    var isMobileZoom = this.state.isMobileZoom;
    var fullscreenStyle = this.props.styles.expandInfoPosition === _consts["default"].expandInfoPositions.BOTTOM ? {
      overflowY: 'visible',
      overflowX: 'hidden'
    } : {};
    return isMobile ? _react["default"].createElement("div", {
      ref: function ref(_ref) {
        return _this11.element = _ref;
      },
      "data-hook": "fullscreen-view",
      id: "fullscreen-view",
      className: this.getFullscreenClasses(),
      role: "dialog",
      "aria-label": "Gallery item, detailed view"
    }, isMobileZoom ? null : this.getDesktopNavbar(curItem, totalItems), isMobileZoom ? null : this.getTopMobileBar(curItem), !isMobileZoom && this.hasAdditionalSidebarElement() ? this.getSideBar() : null, isMobileZoom ? this.getCloseButton() : null, this.getSlider(totalItems), isMobileZoom ? null : this.getFullscreenShareScreen()) : _react["default"].createElement("div", {
      "data-hook": "fullscreen-view",
      id: "fullscreen-view",
      className: this.getFullscreenClasses(),
      style: fullscreenStyle,
      role: "dialog",
      "aria-label": "Gallery item, detailed view"
    }, this.getBottomLinkContainer(), this.getSlider(totalItems), this.getSideBar(), this.getDesktopNavbar(curItem, totalItems));
  };

  return ProFullscreen;
}(_react["default"].Component);

ProFullscreen.defaultProps = {
  items: [],
  initialIdx: 0,
  locale: 'en',
  deviceType: 'desktop',
  isPreview: false,
  viewMode: 'SITE'
};
var _default = ProFullscreen;
exports["default"] = _default;